module.exports = __webpack_public_path__ + "img/pay_default_img.24fc737.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_default_img.png
// module id = ZSGg
// module chunks = 1